import React, {useEffect, useLayoutEffect} from 'react';
import {
    ImgHTMLAttributes,
    memo,
    ReactElement,
    useState,
} from 'react';

interface AppImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    className?: string;
    errorFallback?: ReactElement;
    isLoadingFallback?: ReactElement;
}

export const AppImage = memo((props: AppImageProps) => {
    const {
        className,
        isLoadingFallback,
        errorFallback,
        src,
        alt = 'image',
        ...otherProps
    } = props;

    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useLayoutEffect(() => {
        let mounted = true

        const img = new Image();
        img.src = src ?? '';

        img.onload = () => {
            if (mounted) {
                setIsLoading(false);
            }
        };

        img.onerror = () => {
            if (mounted) {
            setIsLoading(false);
            setIsError(true);
            }
        };

        return () => {
            img.src = '';
            mounted = false
        }
    }, [src]);

    if (isLoading && isLoadingFallback) {
        return isLoadingFallback;
    }

    if (isError && errorFallback) {
        return errorFallback;
    }

    return <img className={className} alt={alt} src={src} {...otherProps} />;
});
